import { useContext } from "react";
import { TextField, Grid } from "@mui/material/";
import { AuthContext } from "../../../../../../../contexts";

import "./personalInformation.css";
import { formatSSN } from "../../../../../../../utils/commonFunctions/SSN";
import { formatZIP } from "../../../../../../../utils/commonFunctions/ZIP";

const PersonalInformation = (): JSX.Element => {
	const { member } = useContext(AuthContext);

	if (member === null) {
		return <></>;
	}

	return (
		<div className="personal-information" id="personal-information">
			<div className="group-information">
				<Grid container spacing={1}>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="grid-items">
						<div className="label">Group/Employee/Participating Organization Name</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="group_name"
								value={member?.group.name}
								style={{
									width: "360px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Country</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="country"
								value={member?.country}
								style={{
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Zip</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="ZIP"
								value={formatZIP(member.ZIP)}
								style={{
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">State</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="state"
								value={member.state}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="self-information">
				<Grid container spacing={1}>
					<Grid item xs={12} sm={12} md={5} lg={5} xl={5} className="grid-items">
						<Grid container spacing={1}>
							<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
								<div className="label">First Name</div>
								<div className="text-field">
									<TextField
										className="text-field"
										id="text-field"
										variant="standard"
										name="first_name"
										value={member.first_name}
										//onChange={props.handleEnrollmentChange}
										style={{
											//width: "360px",
											borderRadius: 50
										}}
									/>
								</div>
							</Grid>
							<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
								<div className="label">Middle Name</div>
								<div className="text-field">
									<TextField
										className="text-field"
										id="text-field"
										variant="standard"
										name="middle_name"
										value={member.middle_name}
										style={{
											//width: "360px",
											borderRadius: 50
										}}
									/>
								</div>
							</Grid>
							<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
								<div className="label">Last Name</div>
								<div className="text-field">
									<TextField
										className="text-field"
										id="text-field"
										variant="standard"
										name="last_name"
										value={member.last_name}
										style={{
											//width: "360px",
											borderRadius: 50
										}}
									/>
								</div>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Social Security No.</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="SSN"
								value={formatSSN(member.SSN)}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Employee ID No.</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="employee_id"
								value={member.member_id}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Date of Birth</div>
						<div className="text-field">
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									variant="standard"
									placeholder="MM"
									name="month"
									value={new Date(member.date_of_birth).getMonth() + 1}
									style={{
										width: "30px",
										borderRadius: 50
									}}
								/>
							</span>
							/
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									variant="standard"
									placeholder="DD"
									name="day"
									value={new Date(member.date_of_birth).getDate()}
									style={{
										marginLeft: "3px",
										width: "30px",
										borderRadius: 50
									}}
								/>
							</span>
							/
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									variant="standard"
									placeholder="YYYY"
									name="year"
									value={new Date(member.date_of_birth).getFullYear().toString().substring(2, 4)}
									style={{
										marginLeft: "3px",
										width: "50px",
										borderRadius: 50
									}}
								/>
							</span>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="unique-information">
				<Grid container spacing={1}>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="grid-items">
						<div className="label">Street Address (Include Apt. or Suite No.)</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="address"
								value={member.address_line_1 + " " + member.address_line_2}
								style={{
									width: "360px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">City</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="city"
								value={member.city}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">State</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="state"
								value={member.state}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Zip</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="ZIP"
								value={formatZIP(member.ZIP)}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="contact-information">
				<Grid container spacing={1}>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Home Phone</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								name="home_phone"
								variant="standard"
								value={member.contact_label === "HOME" ? member.phone_number : ""}
								style={{
									// width: "360px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Cell Phone</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="cell_phone"
								value={member.contact_label === "MOBILE" ? member.phone_number : ""}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={2} lg={2} xl={2} className="grid-items">
						<div className="label">Work Phone</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="work_phone"
								value={member.contact_label === "BUSINESS" ? member.phone_number : ""}
								style={{
									// width: "390px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
					<Grid item xs={5} sm={5} md={5} lg={5} xl={5} className="grid-items">
						<div className="label">Email</div>
						<div className="text-field">
							<TextField
								className="text-field"
								id="text-field"
								variant="standard"
								name="email"
								value={member.email}
								style={{
									width: "290px",
									borderRadius: 50
								}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div className="status-information">
				<Grid container spacing={1}>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="grid-items">
						<span className="gender-label">Gender: </span>
						<span className="male-radio-field">
							<input
								type="radio"
								id="male"
								name="male"
								value="male"
								checked={member.gender === "MALE" ? true : false}
							/>
							  <label htmlFor="male">Male</label>
						</span>
						<span className="female-radio-field">
							<input
								type="radio"
								id="female"
								name="female"
								value="female"
								checked={member.gender === "FEMALE" ? true : false}
							/>
							  <label htmlFor="female">Female</label>
						</span>
					</Grid>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="grid-items">
						<span className="gender-label">Marital Status: </span>
						<span className="male-radio-field">
							<input
								type="radio"
								id="married"
								name="married"
								value="married"
								checked={member.marital_status === "MARRIED" ? true : false}
							/>
							  <label htmlFor="male">Married</label>
						</span>
						<span className="female-radio-field">
							<input
								type="radio"
								id="single"
								name="single"
								value="single"
								checked={member.marital_status === "SINGLE" ? true : false}
							/>
							  <label htmlFor="female">Single</label>
						</span>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default PersonalInformation;
